import { useState } from 'react'

import { EMPTY_LIST } from '../../../../constants/common'
import { useDraggingOver, useScreen } from '../../../../hooks'
import { isDirtyForm } from '../../../../utils/formHelpers'
import { useCloseConfirm } from '../../../Form'
import { useEmailFormResize } from '../useEmailFormResize'

import { getEmailFormResizeHandler } from './useEmailForm.utils'

export function useEmailForm({
  getContainerIsDirty,
  getHandleResize = getEmailFormResizeHandler,
  getIsDirty = isDirtyForm,
  resizeConfig,
  onClose,
}) {
  const [blackList, setBlackList] = useState(EMPTY_LIST)
  const [modal, setModal] = useState(null)

  const {
    handleDragOver,
    handleDropFile,
    isDragging,
    ref: draggingRef,
  } = useDraggingOver()

  const {
    handleClose,
    handleCloseConfirmation,
    isCloseConfirm,
    setCloseConfirm,
  } = useCloseConfirm({
    getIsDirty,
    onClose,
  })

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const { fullScreen, handleResizeModal } = useEmailFormResize(resizeConfig)

  function handleCloseModal() {
    setModal(null)
  }

  function checkContainerIsDirty(...args) {
    return getContainerIsDirty?.() || getIsDirty(...args)
  }

  const handleResize = getHandleResize({
    handleResizeModal,
    isMobileScreenSize,
  })

  return {
    blackList,
    checkContainerIsDirty,
    draggingRef,
    fullScreen,
    handleClose,
    handleCloseConfirmation,
    handleCloseModal,
    handleDragOver,
    handleDropFile,
    handleResizeModal: handleResize,
    isCloseConfirm,
    isDragging,
    isMobileScreenSize,
    modal,
    setBlackList,
    setCloseConfirm,
    setModal,
  }
}
